/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	DateTime: `scalar.DateTime` as const,
	AccountStatus: "enum" as const,
	BattleStatus: "enum" as const,
	NotificationType: "enum" as const,
	Query:{
		getRole:{

		},
		getPermission:{

		},
		getMail:{

		},
		loginAsGuest:{

		},
		login:{

		},
		uniqueAuthFromSso:{

		},
		getUser:{

		},
		getFilteredUsers:{
			findManyUserWithFiltersInput:"FindManyUserWithFiltersInput"
		},
		getQuestionById:{

		},
		getRandomQuestions:{

		},
		getBattleQuestion:{

		},
		getTrackingById:{

		},
		getBattlePlayerTrackingById:{

		},
		getAvailableChallengers:{

		},
		getWinner:{

		}
	},
	EError: "enum" as const,
	FindManyUserWithFiltersInput:{
		orderBy:"UserOrderByInput",
		filterBy:"UserFilterByInput"
	},
	UserOrderByInput:{
		email:"OrderByEnum",
		firstName:"OrderByEnum",
		lastName:"OrderByEnum",
		lastConnectionAt:"OrderByEnum",
		role:"OrderByEnum"
	},
	OrderByEnum: "enum" as const,
	UserFilterByInput:{

	},
	Mutation:{
		register:{

		},
		askForResetPassword:{

		},
		resetPassword:{

		},
		verifyEmail:{

		},
		finishRegister:{

		},
		finishRegisterAsGuest:{

		},
		deleteUser:{

		},
		updateUser:{
			updateUserInput:"UpdateUserInput"
		},
		pickAvatar:{

		},
		validateAnswer:{
			validateAnswerInput:"ValidateAnswerInput"
		},
		validateBatchAnswers:{

		},
		acceptChallenge:{

		},
		declineChallenge:{

		},
		createBattle:{

		},
		quitBattle:{

		},
		validateBattleAnswer:{
			input:"ValidateBattleAnswerInput"
		},
		awardBonusCrown:{

		},
		testBattleNotification:{

		},
		addToFriendsList:{

		},
		removeFromFriendsList:{

		}
	},
	UpdateUserInput:{

	},
	ValidateAnswerInput:{

	},
	ValidateBattleAnswerInput:{

	},
	Subscription:{
		battleSubscription:{

		}
	}
}

export const ReturnTypes: Record<string,any> = {
	Health:{
		env:"String",
		time:"String",
		status:"String"
	},
	Permissions:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		roles:"Roles"
	},
	DateTime: `scalar.DateTime` as const,
	Roles:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		permissions:"Permissions",
		users:"User"
	},
	Avatar:{
		id:"String",
		fileName:"String"
	},
	UpdatedUserTokens:{
		access_token:"String",
		refresh_token:"String"
	},
	User:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		status:"AccountStatus",
		email:"String",
		password:"String",
		passwordResetToken:"String",
		passwordResetExpiryDate:"DateTime",
		activateAccountToken:"String",
		activateAccountExpiryDate:"DateTime",
		emailVerified:"Boolean",
		verifyEmailToken:"String",
		verifyEmailExpiryDate:"DateTime",
		firstName:"String",
		lastName:"String",
		username:"String",
		isChallengeable:"Boolean",
		refreshToken:"String",
		role:"Roles",
		roleId:"Int",
		avatar:"Avatar"
	},
	UserPagination:{
		users:"User",
		total:"Int"
	},
	LeaderboardEntry:{
		username:"String",
		position:"Int",
		score:"Int",
		avatar:"Avatar"
	},
	UpdatedUser:{
		username:"String",
		isChallengeable:"Boolean"
	},
	UpdatedUserWithTokens:{
		tokens:"UpdatedUserTokens",
		updatedUser:"UpdatedUser"
	},
	Tokens:{
		access_token:"String",
		refresh_token:"String"
	},
	UniqueAuth:{
		access_token:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		email:"String",
		sub:"Int"
	},
	AuthUser:{
		id:"Int",
		username:"String",
		isChallengeable:"Boolean",
		avatar:"Avatar"
	},
	Mail:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		to:"String",
		data:"String"
	},
	TrackedAnswer:{
		id:"String",
		answerId:"String",
		time:"Float"
	},
	SoloTracking:{
		id:"String",
		userId:"String",
		position:"Int",
		isCompleted:"Boolean",
		finalScore:"Int",
		trackedAnswers:"TrackedAnswer"
	},
	ValidatedAnswer:{
		tracking:"SoloTracking",
		correctAnswerId:"String",
		turn:"Int",
		level:"Int"
	},
	BattleCheck:{
		hasFinishedBattles:"Boolean",
		hasPendingBattles:"Boolean"
	},
	BattleScore:{
		turn:"Int",
		crownCount:"Int",
		badges:"String"
	},
	ChallengeableUser:{
		id:"String",
		username:"String",
		wonBattles:"Float",
		avatar:"Avatar",
		battleStatus:"BattleStatus"
	},
	SentBattles:{
		id:"String",
		username:"String",
		wonBattles:"Float",
		avatar:"Avatar",
		battleStatus:"BattleStatus",
		createdAt:"DateTime"
	},
	BattleUser:{
		username:"String",
		avatar:"Avatar",
		id:"String",
		score:"BattleScore"
	},
	BattleTracking:{
		id:"String",
		battlePlayerTrackingId:"String",
		challenger:"BattleUser",
		challenged:"BattleUser",
		currentPlayerId:"String"
	},
	PendingBattle:{
		id:"String",
		createdAt:"DateTime",
		challenger:"ChallengeableUser",
		ttl:"DateTime",
		updatedAt:"DateTime",
		currentPlayerId:"String"
	},
	FinishedBattle:{
		isWinner:"Boolean",
		isChallenger:"Boolean",
		opponent:"BattleUser",
		date:"DateTime"
	},
	AvailableChallengers:{
		challengeableFriends:"ChallengeableUser",
		challengeableUsers:"ChallengeableUser"
	},
	Winner:{
		opponent:"String",
		isWinner:"Boolean"
	},
	BattleNotification:{
		from:"String",
		type:"NotificationType",
		isWinner:"Boolean",
		battlePlayerTrackingId:"String"
	},
	ValidatedBattleAnswer:{
		currentTurn:"Int",
		badges:"String",
		crownCount:"Int",
		correctAnswerId:"String",
		turnEnded:"Boolean"
	},
	ValidatedCrown:{
		crownCount:"Int"
	},
	Friend:{
		id:"String",
		username:"String",
		wonBattles:"Int",
		avatar:"Avatar",
		isFriend:"Boolean",
		createdAt:"DateTime"
	},
	Theme:{
		id:"String",
		name:"String",
		fileName:"String",
		wheelFileName:"String"
	},
	Picture:{
		id:"String",
		fileName:"String"
	},
	CurrentThemeAnswers:{
		index:"Int",
		isCorrect:"Boolean"
	},
	PartialAnswer:{
		id:"String",
		text:"String"
	},
	Question:{
		id:"String",
		text:"String",
		theme:"Theme",
		answers:"PartialAnswer",
		picture:"Picture"
	},
	QuestionsWithStatus:{
		questions:"Question",
		currentThemeAnswers:"CurrentThemeAnswers"
	},
	Query:{
		getHealthGql:"Health",
		getRole:"Roles",
		getRoles:"Roles",
		getPermission:"Permissions",
		getPermissions:"Permissions",
		getMail:"Mail",
		getMails:"Mail",
		sendMail:"Boolean",
		loginAsGuest:"AuthType",
		login:"AuthType",
		uniqueAuthFromSso:"UniqueAuth",
		getUser:"User",
		getUsers:"User",
		getLeaderboard:"LeaderboardEntry",
		findOpponents:"User",
		getFilteredUsers:"UserPagination",
		getThemes:"Theme",
		getQuestionById:"Question",
		getRandomQuestions:"QuestionsWithStatus",
		getBattleQuestion:"Question",
		getTrackings:"SoloTracking",
		getTrackingById:"SoloTracking",
		getAvatars:"Avatar",
		getBattlePlayerTrackingById:"BattleTracking",
		getAvailableChallengers:"AvailableChallengers",
		getPendingBattles:"PendingBattle",
		getSentBattles:"SentBattles",
		getFinishedBattles:"FinishedBattle",
		getWinner:"Winner",
		checkBattles:"BattleCheck",
		getFriendsList:"Friend"
	},
	AuthType:{
		"...on AuthReponse":"AuthReponse",
		"...on CustomError":"CustomError"
	},
	AuthReponse:{
		tokens:"Tokens",
		user:"AuthUser"
	},
	CustomError:{
		error:"EError",
		message:"String"
	},
	Mutation:{
		register:"AuthType",
		askForResetPassword:"Boolean",
		resetPassword:"Boolean",
		verifyEmail:"Boolean",
		finishRegister:"Boolean",
		finishRegisterAsGuest:"Boolean",
		refresh:"AuthType",
		logout:"Boolean",
		deleteUser:"Boolean",
		updateUser:"UpdatedUserWithTokens",
		createTracking:"SoloTracking",
		pickAvatar:"User",
		validateAnswer:"ValidatedAnswer",
		validateBatchAnswers:"SoloTracking",
		acceptChallenge:"BattleTracking",
		declineChallenge:"Boolean",
		createBattle:"BattleTracking",
		quitBattle:"Boolean",
		validateBattleAnswer:"ValidatedBattleAnswer",
		awardBonusCrown:"ValidatedCrown",
		testBattleNotification:"Boolean",
		addToFriendsList:"User",
		removeFromFriendsList:"User"
	},
	Subscription:{
		battleSubscription:"BattleNotification"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const,
	subscription: "Subscription" as const
}